


















































































import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "default-menu"
})
export default class DefaultMenuComponent extends Vue {}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/default/default-menu.vue